import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  LinkStyled,
  TaglineContainer,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function SubEmployerMore() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerSolutions());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerEmployerSignUp(buttonCTA, section) {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: section ? section : "solutions",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((solution, index) => (
        <>
          <TaglineContainer>
            <TaglineTitle
              dangerouslySetInnerHTML={{ __html: solution?.title }}
            ></TaglineTitle>

            <TaglineSubtitle
              dangerouslySetInnerHTML={{ __html: solution?.subtitle }}
            ></TaglineSubtitle>
          </TaglineContainer>
        </>
      ))}

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => (
          <CardListContainer key={cardIndex} cardNumber={cardIndex}>
            <CardImage src={cards?.image?.data?.attributes?.url} />
            <CardTextContainer>
              <CardText
                type={"title"}
                cardNumber={cardIndex}
                dangerouslySetInnerHTML={{ __html: cards?.title }}
              ></CardText>
              <CardText
                type={"desc"}
                cardNumber={cardIndex}
                dangerouslySetInnerHTML={{ __html: cards?.description }}
              ></CardText>

              {cards?.buttonCTA ? (
                <>
                  <ButtonStyled
                    onClick={() =>
                      triggerEmployerSignUp(
                        cards?.buttonCTA,
                        cardIndex == 1
                          ? "pricing_page_solutions_talent_search"
                          : "pricing_page_solutions_social_media_blasts"
                      )
                    }
                  >
                    {cards?.buttonCTA}
                  </ButtonStyled>
                </>
              ) : (
                <LinkStyled
                  href={"/hiredly-x"}
                  onClick={() =>
                    sendTrackingEvent({
                      event: "CE_elp_hiredly_x_redirect_click",
                      section: "solutions",
                    })
                  }
                  target="_blank"
                >
                  Learn More{" "}
                  <ArrowRightIcon height={20} width={20} stroke="2" />
                </LinkStyled>
              )}
            </CardTextContainer>
          </CardListContainer>
        ))}
      </CardContainer>
    </GridContainerStyled>
  );
}
